var View = require('views/base/view');

var GlossaryItemView = View.extend({
  template: require('./templates/glossary-item'),
  autoRender: true
});

module.exports = GlossaryItemView;
